import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // frame : id d'un Turbo Frame rechargé après chaque sauvegarde (carte simulateur de la
  // fiche deal — les résultats doivent bouger sans recharger la page).
  static values = { url: String, frame: String }
  static targets = ["indicator", "tab", "panel"]

  connect() {
    if (!this.hasFrameValue) return
    // Le rechargement attend la sortie du champ : sinon le Turbo Frame remplace l'input
    // sous les doigts. On repasse donc par là à chaque perte de focus.
    this._onFocusOut = () => setTimeout(() => this.flushReload(), 0)
    this.element.addEventListener("focusout", this._onFocusOut)
  }

  disconnect() {
    if (this._onFocusOut) this.element.removeEventListener("focusout", this._onFocusOut)
  }

  save(event) {
    const field = event.target
    const key = field.name.replace("playbook[", "").replace("]", "")
    const value = field.value
    const stage = field.dataset.playbookStage

    // Un délai par champ : un délai commun annulait l'envoi du champ précédent quand on
    // passait vite d'un champ texte à un autre.
    this._debounces ||= {}
    clearTimeout(this._debounces[key])
    this._debounces[key] = setTimeout(() => {
      delete this._debounces[key]
      this.patch(stage, key, value)
    }, field.type === "textarea" ? 500 : 0)
  }

  patch(stage, key, value) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new FormData()
    body.append("stage", stage)
    body.append(`playbook[${key}]`, value)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token, "Accept": "application/json" },
      body: body
    }).then(res => {
      if (!res.ok) return
      this.showSaved()
      this.reloadFrame()
    })
  }

  reloadFrame() {
    if (!this.hasFrameValue) return
    this._needsReload = true
    this.flushReload()
  }

  flushReload() {
    if (!this._needsReload) return
    const frame = document.getElementById(this.frameValue)
    if (!frame || frame.contains(document.activeElement)) return
    this._needsReload = false
    frame.reload()
  }

  showSaved() {
    if (!this.hasIndicatorTarget) return
    this.indicatorTarget.classList.remove("opacity-0")
    clearTimeout(this._fadeout)
    this._fadeout = setTimeout(() => {
      this.indicatorTarget.classList.add("opacity-0")
    }, 1500)
  }

  switchTab(event) {
    const stage = event.currentTarget.dataset.playbookStageParam
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("bg-gold", tab.dataset.playbookStageParam === stage)
      tab.classList.toggle("text-white", tab.dataset.playbookStageParam === stage)
      tab.classList.toggle("bg-surface-2", tab.dataset.playbookStageParam !== stage)
      tab.classList.toggle("text-text-muted", tab.dataset.playbookStageParam !== stage)
    })
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.playbookStage !== stage)
    })
  }
}
